import React from "react";
import { Helmet } from "react-helmet";
import Navigation from "../../components/Navigation";
import "./About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import Venue from "../../assets/Sixth & Main Event Center building exterior.jpeg";
import Table from "../../assets/venue_white14.jpg";
import Backdrop from "../../assets/backdrop.jpeg";

export default function About() {
  return (
    <div className="About">
      <Helmet>
        <title>About Sixth & Main Event Center - Learn About Our Venue</title>

        {/* SEO description */}
        <meta
          name="description"
          content="Learn about Sixth & Main Event Center’s vision and commitment to providing an all-inclusive event experience, including premium venue rental, décor services, and supplies."
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About Sixth & Main Event Center - Learn About Our Venue"
        />
        <meta
          property="og:description"
          content="Learn about Sixth & Main Event Center’s vision and commitment to providing an all-inclusive event experience, including premium venue rental, décor services, and supplies."
        />
        <meta
          property="og:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />
        <meta
          property="og:url"
          content="https://sixthandmaineventcenter.com/about"
        />
        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="About Sixth & Main Event Center - Learn About Our Venue"
        />
        <meta
          name="twitter:description"
          content="Discover the history and vision of Sixth & Main Event Center. Learn about our versatile event venue rental space and exceptional services."
        />
        <meta
          name="twitter:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://sixthandmaineventcenter.com/about"
        />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Sixth & Main Event Center",
              "url": "https://sixthandmaineventcenter.com",
              "logo": "https://sixthandmaineventcenter.com/sixthandmaineventcenter.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+1-361-765-6189",
                "contactType": "Customer Service",
                "areaServed": "US",
                "availableLanguage": ["English", "Spanish"]
              },
              "sameAs": [
                "https://www.facebook.com/sixthandmaineventcenter/",
                "https://www.instagram.com/6thandmaineventcenter/"
              ]
            }
          `}
        </script>
      </Helmet>

      <div className="hero">
        <Navigation />
        <div className="px-5 px-sm-1">
          <h1 className="text-light">Crafting memories, one event at a time</h1>
        </div>
      </div>

      <div
        name="about"
        className="About py-5"
      >
        <div>
          <div className="container mb-5 d-flex justify-content-center">
            <div className="row container">
              <div className="col col-sm-6 my-auto px-0 px-md-3">
                <h3 className="fs-1">About the venue</h3>
                <p className="">
                  Sixth & Main Event Center is conveniently located in the heart
                  of downtown Robstown, TX. The venue rental space is
                  configurable for Private Parties, Corporate Meetings, and
                  more!
                </p>

                <p className="fw-medium">Occupancy: 75 people.</p>
              </div>
              <div className="col-none col-sm-6 my-auto p-0 p-lg-5 d-flex">
                <img
                  src={Venue}
                  alt="Street view of Sixth & Main Event Center venue"
                  className="img-fluid ms-sm-3 rounded"
                  id="vision-illustration"
                />
              </div>
            </div>
          </div>
          <div className="container d-flex justify-content-center">
            <div className="row container">
              <div className="d-none d-sm-block col-none col-sm-6 my-auto p-1 p-lg-5 rounded">
                <img
                  src={Table}
                  alt="Decorated tables with floral centerpieces against a bright background"
                  className="img-fluid d-block mb-3 mx-auto d-flex rounded"
                  style={{ maxWidth: "90%" }}
                  id="vision-illustration"
                />
              </div>
              <div className="col col-sm-6 my-auto px-0 px-sm-3">
                <h3 className="fs-1">The "IT" Factor</h3>
                <p className="mb-sm-3">
                  Here at Sixth & Main Event Center, we take pride in everything
                  we do. We work with each client to ensure the detail in the
                  decor exceeds their expectations.
                </p>
              </div>
              <div className="d-block d-sm-none col-none col-sm-6 my-auto p-1 p-lg-5 rounded">
                <img
                  src={Table}
                  alt="Decorated tables with floral centerpieces against a bright background"
                  className="img-fluid d-block mb-3 mx-auto d-flex rounded"
                  style={{ maxWidth: "90%" }}
                  id="vision-illustration"
                />
              </div>
            </div>
          </div>

          <div className="container">
            <hr />
            <div
              className="py-4"
              id="uses-container"
            >
              <h3 className="text-start ms-3">Ideal Uses</h3>
              <div className="container text-start ms-sm-3 pe-md-5">
                <div
                  className="row"
                  id="venue-uses"
                >
                  <div className="col-6 col-md-4 text-dark">
                    Celebrate
                    <ul className="ms-2">
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "baby",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Baby Showers
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "rings-wedding",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Bridal Showers
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "graduation-cap",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Graduation Parties
                      </li>
                    </ul>
                  </div>
                  <div className="col-6 col-md-4 text-dark">
                    Gather
                    <ul className="ms-2">
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "cake",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Birthdays
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "award",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Milestones
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "lights-holiday",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Holiday Events
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-4 text-dark">
                    Grow
                    <ul className="ms-2">
                      <li>
                        <FontAwesomeIcon
                          icon={duotone("handshake")}
                          className="me-2"
                        />
                        Employee Appreciation
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "people-group",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Seminars
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon={icon({
                            name: "presentation-screen",
                            family: "duotone",
                            style: "solid",
                          })}
                          className="me-2"
                        />
                        Trainings
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div
            className="py-3 mx-auto px-1 px-sm-2 px-md-5"
            style={{ maxWidth: "1200px" }}
          >
            <table className="table table-light text-center shadow">
              <thead>
                <tr>
                  <th
                    colspan="9"
                    className="fs-1"
                  >
                    Package Pricing
                  </th>
                </tr>
                <tr>
                  <th
                    scope="col"
                    className="text-start text-uppercase"
                  >
                    What's Included
                  </th>
                  <th scope="col">
                    <span
                      className="text-uppercase text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Standard
                    </span>

                    <span className="d-block fs-6">$500</span>
                  </th>
                  <th scope="col">
                    <span
                      className="text-uppercase text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Premium
                    </span>
                    <span className="d-block fs-6">$875</span>
                  </th>
                  <th scope="col">
                    <span
                      className="text-uppercase text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Deluxe
                    </span>
                    <span className="d-block fs-6">$1275</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th
                    scope="row"
                    id="table-row-header"
                  >
                    6 hour Venue Rental, Seating for 75 people & Entry
                    Gift/Dessert Table
                  </th>
                  <td>✓</td>
                  <td>✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <th
                    scope="row"
                    id="table-row-header"
                  >
                    Decorative Services including Table Covers, Runners, and
                    Centerpieces
                  </th>
                  <td></td>
                  <td>✓</td>
                  <td>✓</td>
                </tr>

                <tr>
                  <th
                    scope="row"
                    id="table-row-header"
                  >
                    Photo Backdrop (Balloon, Curtain, or Floral)
                  </th>
                  <td></td>
                  <td></td>
                  <td>✓</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            className="py-5 mb-3 mb-lg-5 graduation"
            style={{ backgroundColor: "rgba(33, 108, 123, 0.1)" }}
          >
            {" "}
            <h3 className="grad-special text-center text-black fs-2 fw-bold text-uppercase">
              <FontAwesomeIcon
                icon={icon({
                  name: "calendar-days",
                  family: "duotone",
                  style: "solid",
                })}
                className="me-2"
              />
              Weekday Special - $400:
            </h3>
            <p className="text-center text-black my-4 my-md-5 mx-auto w-75 fs-4">
              Weekday (Mon - Thur) venue rental for 4 hours, seating for 75, and
              table covers.
            </p>
            <a
              className="btn d-block text-uppercase text-light"
              style={{ backgroundColor: "#055160" }}
              href="/reservation"
              role="button"
              id="book-now"
            >
              <FontAwesomeIcon
                icon={icon({
                  name: "calendar-days",
                  family: "duotone",
                  style: "solid",
                })}
                className="me-2"
              />
              Book Now
            </a>
          </div>

          <div className="decor-samples">
            <div className="container">
              <div className="row container py-3">
                <div className="col-none col-sm-6 my-auto p-0 p-lg-5 rounded">
                  <img
                    src={Backdrop}
                    alt="Baby shower balloon arch decoration at the Sixth & Main Event Center venue"
                    className="w-100 img-fluid d-none d-sm-block mx-auto rounded"
                    id="vision-illustration"
                  />
                </div>

                <div className="col col-sm-6 my-auto">
                  <h3 className="fs-1">
                    Designed to make your celebrations unforgettable
                  </h3>
                  <p className="mb-0">
                    Whether you're hosting a community event or celebrating a
                    personal milestone, our venue can be tailored to suit your
                    vision.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <hr />
            <div
              className="container py-4 mb-2"
              id="amenities-container"
            >
              <h3 className="text-start">Amenities</h3>
              <div className="container ms-3 px-0">
                <div
                  className="row w-100"
                  id="venue-amenities"
                >
                  <div className="col">
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "table-picnic",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2 text-start"
                      />
                      Tables
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "chair",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Chairs
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "rug",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Linens
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "wheelchair",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Accessible
                    </p>
                  </div>
                  <div className="col">
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "restroom",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Restroom
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "microwave",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Kitchenette*
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "refrigerator",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Fridge
                    </p>
                    <p>
                      <FontAwesomeIcon
                        icon={icon({
                          name: "square-parking",
                          family: "duotone",
                          style: "solid",
                        })}
                        className="me-2"
                      />
                      Onsite Parking
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <p>
              *Roasters and similar high‑wattage appliances cannot be plugged
              into the venue’s outlets; please bring chafing dishes or other
              external heating elements to keep food warm.
            </p>
            <hr />
          </div>

          <div
            className="about-container my-4"
            id="banner-about"
          >
            <p className="text-light text-center m-0 px-5 px-sm-4">
              Custom centerpieces made to awe
            </p>
          </div>

          <div className="container map-embed mb-3">
            <h3 className="fs-1">The location</h3>
            <p>
              Located on the corner of 6th Street & Main Avenue, our venue is
              easily accessible and surrounded by the charm & character of
              Robstown, TX.
            </p>

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d727.19802050513!2d-97.66222709337386!3d27.78950786363994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86687db053a405f9%3A0x6afa62d440481b8d!2sSixth%20%26%20Main%20Event%20Center!5e0!3m2!1sen!2sus!4v1700076225668!5m2!1sen!2sus"
              width="300"
              height="300"
              allowFullScreen=""
              className="border-0 rounded w-100"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Map and Directions to Sixth & Main Event Center Venue"
              alt="Embedded map of the venue Sixth & Main Event Center in Robstown, Texas"
            ></iframe>
          </div>

          <div className="container">
            <a
              href="/reservation"
              className="btn btn-primary mt-3 d-block m-auto text-uppercase"
              role="button"
            >
              <FontAwesomeIcon
                icon={icon({
                  name: "calendar-days",
                  family: "duotone",
                  style: "solid",
                })}
                className="me-2"
              />
              Book Now!
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
